import { ScheduleItemType } from 'remote/global';
import { MuiTelInputCountry } from 'mui-tel-input';

// List of countries in European Economic Area
export const PREFERRED_INPUT_COUNTRY_CODES: MuiTelInputCountry[] = [
  'EE',
  'LV',
  'LT',
  'PL',
  'FI',
  'DE',
];

export const countryOriginOptions = ['EE', 'LV', 'GB'] as const;

export const countryOfOriginOptions: {
  label: string;
  value: (typeof countryOriginOptions)[number];
}[] = [
  {
    label: 'Eesti',
    value: 'EE',
  },
  {
    label: 'Latvija',
    value: 'LV',
  },
  {
    label: 'United Kingdom',
    value: 'GB',
  },
];

export const DEFAULT_VACATION_TYPE = ScheduleItemType.VACATION;
